module.exports = __webpack_public_path__ + "static/images/tutorial-1.50929a94f32ebe9652901b892ddb24bc.svg";